import React, { useState, useRef, useCallback } from 'react';
import proptypes from 'prop-types';
import { TileComponent } from './tile-component';
import {
  getMouseEnterHandler,
  getMouseLeaveHandler,
  isMovingToPopover,
  shouldShowTooltipCondition,
  shouldShowUnavailableTooltipCondition,
  shouldShowOOSTooltipCondition
} from '../../super-sku-util';

const { string, shape, bool, func } = proptypes;

export const Tile = (
  {
    isSelected,
    isAvailable,
    isFabricType = false,
    value,
    onClick,
    onMouseEnter,
    onMouseLeave,
    isTooltipsEnabled = false,
    hoveredCombinationDetails = {},
    channel = 'desktop',
    isOOS = false,
    isUnavailable = false,
    unavailableTooltipMessage = '',
    oosTooltipMessage = ''
  }
) => {
  const [isHovered, setIsHovered] = useState(false);
  const anchorElRef = useRef(null);
  const isMobile = channel === 'mobile';

  const mouseEnter = useCallback(
    getMouseEnterHandler(isMobile, setIsHovered, onMouseEnter, anchorElRef),
    [isMobile, onMouseEnter]
  );

  const mouseLeave = useCallback(
    getMouseLeaveHandler(isMobile, setIsHovered, onMouseLeave, anchorElRef),
    [isMobile, onMouseLeave]
  );

  const mouseLeaveEvent = useCallback(
    (event) => {
      if (anchorElRef.current && isMovingToPopover(event)) return;
      mouseLeave(event);
    },
    [mouseLeave]
  );

  const shouldShowOOSTTooltip = !!oosTooltipMessage && shouldShowOOSTooltipCondition(
    isHovered, isTooltipsEnabled, hoveredCombinationDetails, isFabricType
  );

  const shouldShowUnavailableTooltip = !shouldShowOOSTTooltip
  && shouldShowUnavailableTooltipCondition(unavailableTooltipMessage,
    isHovered, isTooltipsEnabled, hoveredCombinationDetails, false, isFabricType
  );

  const shouldShowTooltip = !shouldShowOOSTTooltip && !shouldShowUnavailableTooltip
  && shouldShowTooltipCondition(isHovered, isTooltipsEnabled, hoveredCombinationDetails, false, isFabricType);

  return (
    <TileComponent
      value={value}
      isSelected={isSelected}
      isAvailable={isAvailable}
      isFabricType={isFabricType}
      onClick={onClick}
      onTileMouseEnter={mouseEnter}
      onTileMouseLeave={mouseLeaveEvent}
      anchorRef={anchorElRef}
      hoveredCombinationDetails={hoveredCombinationDetails}
      onPopoverClose={mouseLeave}
      showMainTooltip={shouldShowTooltip}
      showUnavailableTooltip={shouldShowUnavailableTooltip}
      shouldShowOOSTTooltip={shouldShowOOSTTooltip}
      isOOS={isOOS}
      isUnavailable={isUnavailable}
      unavailableTooltipMessage={unavailableTooltipMessage}
      oosTooltipMessage={oosTooltipMessage}
    />
  );
};

Tile.displayName = 'Tile';

Tile.propTypes = {
  channel: string,
  value: string.isRequired,
  isAvailable: bool.isRequired,
  isFabricType: bool,
  isSelected: bool.isRequired,
  onClick: func.isRequired,
  onMouseEnter: func.isRequired,
  onMouseLeave: func.isRequired,
  isTooltipsEnabled: bool,
  hoveredCombinationDetails: shape({}),
  isOOS: bool,
  isUnavailable: bool,
  unavailableTooltipMessage: string,
  oosTooltipMessage: string,
};